// extracted by mini-css-extract-plugin
export default {"content":"OperationsStatement_content__qJB+B","header":"OperationsStatement_header__7bTrj","list":"OperationsStatement_list__lkg-S"};